/**
 *
 * Asynchronously loads the component for Lockbox files
 *
 */

 import loadable from '../../utils/loadable';

 export default loadable(() => import('./index'));
 